import { DictItem, DictData } from './index'
import { GetLocalStorage } from '../../tools/util'

// 字典数据存储 key
const DICT_STORAGE_KEY = 'DICT_DATA'

/**
 * 从 Redux store 或 localStorage 获取字典数据
 * @param dictData Redux 中的字典数据（可选）
 * @returns 字典数据对象
 */
function getDictDataFromStore(dictData?: DictData): DictData {
  // 优先使用 Redux 中的数据
  if (dictData && Object.keys(dictData).length > 0) {
    return dictData
  }

  // 如果 Redux 中没有，从 localStorage 读取
  const localData = GetLocalStorage(DICT_STORAGE_KEY as any)
  return localData || {}
}

/**
 * 根据字典编码获取字典项列表
 * @param dictCode 字典编码
 * @param dictData Redux 中的字典数据（可选）
 * @returns 字典项列表
 */
export function getDictList(dictCode: string, dictData?: DictData): DictItem[] {
  const data = getDictDataFromStore(dictData)
  return data[dictCode] || []
}

/**
 * 根据字典编码和值获取字典标签
 * @param dictCode 字典编码
 * @param dictValue 字典值（对应 detailList 中的 key）
 * @param dictData Redux 中的字典数据（可选）
 * @returns 字典标签（对应 detailList 中的 value）
 */
export function getDictLabel(
  dictCode: string,
  dictValue: string | number,
  dictData?: DictData,
): string {
  const list = getDictList(dictCode, dictData)
  const item = list.find((item) => String(item.key) === String(dictValue))
  return item?.value || String(dictValue)
}

/**
 * 根据字典编码和标签获取字典值
 * @param dictCode 字典编码
 * @param dictLabel 字典标签（对应 detailList 中的 value）
 * @param dictData Redux 中的字典数据（可选）
 * @returns 字典值（对应 detailList 中的 key）
 */
export function getDictValue(
  dictCode: string,
  dictLabel: string,
  dictData?: DictData,
): string {
  const list = getDictList(dictCode, dictData)
  const item = list.find((item) => item.value === dictLabel)
  return item?.key || ''
}

/**
 * // 获取字典数据
const dictData = useTypedSelector((state) => state.dictData.dictData)

// 1. 获取品类字典列表
const categoryList = getDictList('SYSTEM.CATEGORY', dictData)
// 返回: [{ key: "0", value: "默认品类" }, { key: "1", value: "办公品" }, ...]

// 2. 根据 key 获取 value（显示标签）
const categoryLabel = getDictLabel('SYSTEM.CATEGORY', '1', dictData)
// 返回: "办公品"

// 3. 获取 Select 选项
const categoryOptions = getDictOptions('SYSTEM.CATEGORY', dictData)
// 返回: [{ label: "默认品类", value: "0" }, { label: "办公品", value: "1" }, ...]

// 4. 根据 value 获取 key（表单提交）
const categoryKey = getDictValue('SYSTEM.CATEGORY', '办公品', dictData)
// 返回: "1"
 * 
 */

/**
 * 根据字典编码获取字典选项（用于 Select 组件）
 * @param dictCode 字典编码
 * @param dictData Redux 中的字典数据（可选）
 * @returns Select 选项数组 { label, value }
 */
export function getDictOptions(
  dictCode: string,
  dictData?: DictData,
): Array<{ label: string; value: string }> {
  const list = getDictList(dictCode, dictData)
  return list.map((item) => ({
    label: item.value, // detailList 中的 value 作为 label
    value: item.key, // detailList 中的 key 作为 value
  }))
}

/**
 * 检查字典编码是否存在
 * @param dictCode 字典编码
 * @param dictData Redux 中的字典数据（可选）
 * @returns 是否存在
 */
export function hasDictCode(dictCode: string, dictData?: DictData): boolean {
  const data = getDictDataFromStore(dictData)
  return dictCode in data
}
import { DictItem, DictData } from './index'
import { GetLocalStorage } from '../../tools/util'

// 字典数据存储 key
const DICT_STORAGE_KEY = 'DICT_DATA'

/**
 * 从 Redux store 或 localStorage 获取字典数据
 * @param dictData Redux 中的字典数据（可选）
 * @returns 字典数据对象
 */
function getDictDataFromStore(dictData?: DictData): DictData {
  // 优先使用 Redux 中的数据
  if (dictData && Object.keys(dictData).length > 0) {
    return dictData
  }

  // 如果 Redux 中没有，从 localStorage 读取
  const localData = GetLocalStorage(DICT_STORAGE_KEY as any)
  return localData || {}
}

/**
 * 根据字典编码获取字典项列表
 * @param dictCode 字典编码
 * @param dictData Redux 中的字典数据（可选）
 * @returns 字典项列表
 */
export function getDictList(dictCode: string, dictData?: DictData): DictItem[] {
  const data = getDictDataFromStore(dictData)
  return data[dictCode] || []
}

/**
 * 根据字典编码和值获取字典标签
 * @param dictCode 字典编码
 * @param dictValue 字典值（对应 detailList 中的 key）
 * @param dictData Redux 中的字典数据（可选）
 * @returns 字典标签（对应 detailList 中的 value）
 */
export function getDictLabel(
  dictCode: string,
  dictValue: string | number,
  dictData?: DictData,
): string {
  const list = getDictList(dictCode, dictData)
  const item = list.find((item) => String(item.key) === String(dictValue))
  return item?.value || String(dictValue)
}

/**
 * 根据字典编码和标签获取字典值
 * @param dictCode 字典编码
 * @param dictLabel 字典标签（对应 detailList 中的 value）
 * @param dictData Redux 中的字典数据（可选）
 * @returns 字典值（对应 detailList 中的 key）
 */
export function getDictValue(
  dictCode: string,
  dictLabel: string,
  dictData?: DictData,
): string {
  const list = getDictList(dictCode, dictData)
  const item = list.find((item) => item.value === dictLabel)
  return item?.key || ''
}

/**
 * // 获取字典数据
const dictData = useTypedSelector((state) => state.dictData.dictData)

// 1. 获取品类字典列表
const categoryList = getDictList('SYSTEM.CATEGORY', dictData)
// 返回: [{ key: "0", value: "默认品类" }, { key: "1", value: "办公品" }, ...]

// 2. 根据 key 获取 value（显示标签）
const categoryLabel = getDictLabel('SYSTEM.CATEGORY', '1', dictData)
// 返回: "办公品"

// 3. 获取 Select 选项
const categoryOptions = getDictOptions('SYSTEM.CATEGORY', dictData)
// 返回: [{ label: "默认品类", value: "0" }, { label: "办公品", value: "1" }, ...]

// 4. 根据 value 获取 key（表单提交）
const categoryKey = getDictValue('SYSTEM.CATEGORY', '办公品', dictData)
// 返回: "1"
 * 
 */

/**
 * 根据字典编码获取字典选项（用于 Select 组件）
 * @param dictCode 字典编码
 * @param dictData Redux 中的字典数据（可选）
 * @returns Select 选项数组 { label, value }
 */
export function getDictOptions(
  dictCode: string,
  dictData?: DictData,
): Array<{ label: string; value: string }> {
  const list = getDictList(dictCode, dictData)
  return list.map((item) => ({
    label: item.value, // detailList 中的 value 作为 label
    value: item.key, // detailList 中的 key 作为 value
  }))
}

/**
 * 检查字典编码是否存在
 * @param dictCode 字典编码
 * @param dictData Redux 中的字典数据（可选）
 * @returns 是否存在
 */
export function hasDictCode(dictCode: string, dictData?: DictData): boolean {
  const data = getDictDataFromStore(dictData)
  return dictCode in data
}
